<template lang="pug">
  v-btn(
    @click="$createOnClick({ donate: onClick })"
    color="primary"
    style="width: 96px"
    rounded) Don
</template>

<script>
import { page } from '@iez/core'
import { ref, computed } from '@vue/composition-api'
import createOnClick from '@iez/lib/create-on-click/'
import router from '@iez/core/router/'
import { injectRouteState } from '@iez/core'
import isUserBlocked from '@/shared/is-user-blocked/'

export default {
  setup () {
    const routeState = injectRouteState()

    const menu = ref(false)

    const isDisabled = isUserBlocked
    const itemDonate = computed(
      () => isDisabled.value
        ? null
        : {
          label: `Nos services`,
          onClick: createOnClick({
            yako: () => {
              router.push({
                name: `DonateToAssociation`,
                params: {
                  associationId: routeState.user.association.id
                }
              })
            }
          })
        }
    )

    page.blockingMenu.set(
      () => menu.value
        ? {
          title: `Utiliser :`,
          items: [
            itemDonate.value, {
              label: `HelloAsso`,
              onClick: createOnClick({
                helloAsso: () => {
                  page.blockingDialog.set({
                    title: `Essayez ultérieurement`,
                    content: `Cette fonctionnalité n'est pas disponible pour le moment. Nous travaillons d'arrache-pied pour son arrivée prochaine`,
                    action1: {
                      label: `Fermer`,
                      onClick: () => {
                        page.blockingDialog.unset()
                      }
                    }
                  })
                }
              })
            }
          ].filter(Boolean),
          onClose: () => {
            menu.value = false
          }
        } : null
    )

    const onClick = () => {
      menu.value = true
    }

    return {
      onClick
    }
  }
}
</script>
